import { Card, CardContent, Grid, Typography, WithStyles } from "@material-ui/core";
import { useHistory } from "react-router-dom";
import { withStyles } from "@material-ui/core/styles";
import React from "react";
import { styles } from "./BasketView.styles";
import { useTranslation } from "react-i18next";
import { isAddressExist } from "../../utilities/userUtils";
import { BlueButton } from "../components/Buttons/BlueButton";
import * as UserDetailsAction from "../../stores/user/UserDetailsAction";
import { useDispatch, useSelector } from "react-redux";
import { useAuthContext } from "../../auth/AuthProvider";
import { isEuCountry } from "../../utilities/countriesUtils";
import { selectVisibleCountries } from "../../selectors/countries/CountriesSelector";

/*
    This is the second step of the checkout, here the user can check and forward to changing the adress and user information.
*/

export interface IBasketViewAddressProps extends WithStyles<typeof styles> {
    userDetails: any,
    buttons?: boolean,
    setDeliveryAddressFilled?: any,
    setVatIdFilled?: any
}

const BasketViewAddressPure: React.FunctionComponent<IBasketViewAddressProps> = ({
                                                                                     classes,
                                                                                     buttons,
                                                                                     setDeliveryAddressFilled,
                                                                                     setVatIdFilled
                                                                                 }: IBasketViewAddressProps) => {

    const history = useHistory();
    const {t} = useTranslation();
    const dispatch = useDispatch();
    const authContext = useAuthContext();
    const userId = authContext?.user?.id;
    const countries = useSelector(state => selectVisibleCountries(state));

    const userDetails = useSelector(state => state.userDetails?.currentlyLoggedUser);
    React.useEffect(() => {
        dispatch(UserDetailsAction.requestCurrentUser(userId));
    }, [dispatch, userId]);

    const handleChange = () => {
        history.push("/my-account/personal-data/redirect=checkout");
    };

    if (userDetails && setDeliveryAddressFilled) {
        if (isAddressExist(userDetails.deliveryAddress)) {
            setDeliveryAddressFilled(true);
            if (isEuCountry(countries, userDetails.deliveryAddress.country)) {
                setVatIdFilled(userDetails.tin !== "");
            } else {
                setVatIdFilled(true);
            }
        } else {
            setDeliveryAddressFilled(false);
        }
    }

    return userDetails
        ? <>
            {buttons
                ? <Typography className={classes.sectionHeadline} variant="h3">{t("basket.reviewAddress")}</Typography>
                : null
            }
            <Grid container direction="row" spacing={3}>
                <Grid item xs={4}>
                    <Card className={classes.userCardSmall} variant="outlined">
                        <CardContent>
                            <Typography variant="subtitle2">{t("orderDetails.title.billingAddress")}</Typography>
                            <Typography variant="body2">{userDetails.firstName} {userDetails.lastName}</Typography>
                            <Typography variant="body2">{userDetails.billingAddress.addressLine1}</Typography>
                            {(userDetails.billingAddress.addressLine2 !== "")
                                ? <Typography variant="body2">{userDetails.billingAddress.addressLine2}</Typography>
                                : null
                            }
                            <Typography
                                variant="body2">{userDetails.billingAddress.postcode} {userDetails.billingAddress.city}</Typography>
                            <Typography className={classes.bottomMargin}
                                        variant="body2">{userDetails.billingAddress.country}</Typography>
                        </CardContent>
                    </Card>
                    {buttons
                        ? <BlueButton
                            onClick={handleChange}
                        >{t("basket.changeBilling")}</BlueButton>
                        : null
                    }
                </Grid>
                {isAddressExist(userDetails.deliveryAddress)
                    ? <Grid item xs={4}>
                        <Card className={classes.userCardSmall} variant="outlined">
                            <CardContent>
                                <Typography variant="subtitle2">{t("general.deliveryAddress")}</Typography>
                                <Typography variant="body2">{userDetails.deliveryAddress.name}</Typography>
                                <Typography variant="body2">{userDetails.deliveryAddress.addressLine1}</Typography>
                                {(userDetails.deliveryAddress.addressLine2 !== "")
                                    ? <Typography variant="body2">{userDetails.deliveryAddress.addressLine2}</Typography>
                                    : null
                                }
                                <Typography
                                    variant="body2">{userDetails.deliveryAddress.postcode} {userDetails.deliveryAddress.city}</Typography>
                                <Typography className={classes.bottomMargin}
                                            variant="body2">{userDetails.deliveryAddress.country}</Typography>
                            </CardContent>
                        </Card>
                        {buttons
                            ? <BlueButton
                                onClick={handleChange}
                            >{t("basket.changeDelivery")}</BlueButton>
                            : null
                        }
                    </Grid>
                    : <Grid item xs={4}>
                        <Card className={classes.userCardSmall} variant="outlined">
                            <CardContent>
                                <Typography variant="subtitle2">{t("general.deliveryAddress")}</Typography>
                                <Typography className={classes.bottomMargin}
                                            variant="body2">{t("basket.noDeliveryAddress")}</Typography>
                            </CardContent>
                        </Card>
                        {buttons
                            ? <BlueButton
                                onClick={handleChange}
                            >{t("basket.addDelivery")}</BlueButton>
                            : null
                        }
                    </Grid>
                }
                <Grid item xs={4}>
                    <Card className={classes.userCardSmall} variant="outlined">
                        <CardContent>
                            <Typography variant="subtitle2">{t("basket.userInfo")}</Typography>
                            <Typography variant="body2">{userDetails.firstName} {userDetails.lastName}</Typography>
                            <Typography variant="body2">{userDetails.phone}</Typography>
                            <Typography className={classes.bottomMargin} variant="body2">{userDetails.email}</Typography>
                            {(userDetails.organization !== "")
                                ? <Typography variant="body2">{userDetails.organization}</Typography>
                                : null
                            }
                            {userDetails.tin !== ""
                                ? <Typography variant="body2">VAT ID: {userDetails.tin}</Typography>
                                : userDetails.deliveryAddress.country && isEuCountry(countries, userDetails.deliveryAddress.country) &&
                                <Typography variant="body2" className={classes.paymentError}>VAT ID is mandatory for EU
                                    residents!</Typography>
                            }
                        </CardContent>
                    </Card>
                    {buttons
                        ? <BlueButton
                            onClick={handleChange}
                        >{t("basket.changeUserInfo")}</BlueButton>
                        : null
                    }
                </Grid>
            </Grid>
        </> : null;
};

export const BasketViewAddress = withStyles(styles)(BasketViewAddressPure);
